import notice from "../notice";
import {clone} from "../../js/tool";

const cultureNotice = clone(notice);
cultureNotice.url = "/admin/mini-notice";
cultureNotice.name = "公告";
export default cultureNotice;
